import React from "react";
import Navbar from "../../Navbar/Navbar";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
import { Link } from "react-router-dom";
// import { FaAngleRight } from "react-icons/fa";
// import img from '../../../assets/details.jpg' ;
import img from '../../../assets/new-banners/any_product_banner.jpg' ;
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
// import { GrLinkNext } from "react-icons/gr";
import { GrFormNextLink } from "react-icons/gr";




const Hero = ({productTitle}) => {
  return (
    <section className={styles.hero_mainContainer} style={{backgroundImage: `url(${img})`}}>
      <Navbar />
      <MobileNavbar />

      <div className={styles.hero_container} >
        <div className={styles.hero_content_container}>
          <div className={styles.order_container}>
            <h1 className={styles.hero_heading}>{productTitle}</h1>
            <button className={styles["product___btn"]} >
              <Link to={'/order'}><MdOutlineProductionQuantityLimits/> | Order Now</Link>
            </button>
          </div>
          <div className={styles.links_container}>
            <Link to='/products' className={styles.links_container__link}>
            All Products <GrFormNextLink className={styles.__rightarrow} />
            </Link>
            <Link to='/products/products_healthcare' className={styles.links_container__link}>
            Health-Care Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/products/products_commercial' className={styles.links_container__link}>
            Commercial Products
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
